/**
 * ★ THE BRAND FILE ★
 *
 * Everything the Rainmaker Marketing identity touches lives here and nowhere
 * else. No React, no Mantine, no imports — just data, so that a rebrand (or a
 * switch to the licensed brand face) is a single-file edit.
 *
 * Values were taken from the live site's Elementor global kit and the favicon
 * artwork, so they are the real brand colours rather than an eyeballed match.
 */

export const brand = {
  name: 'Rainmaker',
  productName: 'Rainmaker Board',

  colors: {
    /** Deep navy — app chrome, headers, primary text. */
    navy: '#0f2b49',
    /** Teal — the primary action colour. */
    teal: '#028880',
    /** Lime — accent: drop indicators, highlights, focus glow. */
    lime: '#dde466',
    /** Warm sand — board background, column headers. */
    sand: '#e3dcd2',
    /** Near-black body text. */
    ink: '#1a1a1a',
    white: '#ffffff',
  },

  /**
   * The brand face is `forma-djr-text` (Adobe Fonts kit `lcx1ieu`). Adobe kits
   * are locked to specific domains, so the board ships with Inter — the closest
   * free neo-grotesque — self-hosted to satisfy the `font-src 'self'` CSP.
   *
   * To switch to the real face later: authorise the board's hostname in
   * Adobe Fonts, load the kit, and change `body` below. Nothing else moves.
   */
  fonts: {
    body: "'Inter Variable', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    mono: "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace",
  },

  radii: { xs: '3px', sm: '5px', md: '8px', lg: '12px', xl: '18px' },

  shadows: {
    card: '0 1px 2px rgba(15, 43, 73, 0.06), 0 1px 3px rgba(15, 43, 73, 0.08)',
    cardHover: '0 4px 10px rgba(15, 43, 73, 0.10), 0 2px 4px rgba(15, 43, 73, 0.08)',
    cardDragging: '0 12px 28px rgba(15, 43, 73, 0.22)',
    panel: '0 8px 30px rgba(15, 43, 73, 0.14)',
    modal: '0 24px 70px rgba(15, 43, 73, 0.30)',
  },

  logo: {
    mark: '/brand/mark.svg',
    wordmarkWhite: '/brand/wordmark-white.svg',
  },
} as const;

export type Brand = typeof brand;
